import { Card } from './card';

/** Dark glass gradient card with orb accents (static — no motion). */
export default function HighlightCard({ title, description, icon }) {
  return (
    <div className="h-full min-w-0">
      <Card className="text-white h-full min-w-0 rounded-2xl border border-white/15 bg-gradient-to-br from-[#010101] via-[#090909] to-[#010101] shadow-2xl relative backdrop-blur-xl overflow-hidden w-full">
        <div className="absolute inset-0 z-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-tr from-white/5 to-white/10 opacity-50" />
          <div className="absolute -bottom-20 -left-20 w-48 h-48 rounded-full bg-gradient-to-tr from-[#2568ff]/25 to-transparent blur-3xl opacity-40" />
          <div className="absolute top-10 left-10 w-16 h-16 rounded-full bg-white/5 blur-xl" />
          <div className="absolute bottom-16 right-16 w-12 h-12 rounded-full bg-white/5 blur-lg" />
        </div>

        <div className="p-5 sm:p-6 lg:p-8 relative z-10 flex flex-col items-center text-center">
          <div className="relative mb-4 sm:mb-6">
            <div className="absolute inset-0 rounded-full border-2 border-white/20 opacity-60" />
            <div className="absolute inset-0 rounded-full border border-white/10 opacity-40" />

            <div className="p-4 sm:p-5 lg:p-6 rounded-full backdrop-blur-lg border border-white/20 bg-gradient-to-br from-black/80 to-black/60 shadow-2xl [&_svg]:w-6 [&_svg]:h-6 sm:[&_svg]:w-7 sm:[&_svg]:h-7 lg:[&_svg]:w-8 lg:[&_svg]:h-8">
              {icon}
            </div>
          </div>

          <h3 className="mb-4 text-xl sm:text-2xl md:text-[1.65rem] font-bold leading-snug bg-gradient-to-r from-white via-gray-100 to-white bg-clip-text text-transparent">
            {title}
          </h3>

          <div className="space-y-2 w-full max-w-[42ch] px-1 sm:px-0 mx-auto">
            {description.map((line, idx) => (
              <p key={idx} className="text-gray-300 text-sm leading-relaxed sm:text-base">
                {line}
              </p>
            ))}
          </div>

          <div className="mt-6 w-2/5 max-w-[140px] h-0.5 bg-gradient-to-r from-transparent via-white/90 to-transparent rounded-full" />

          <div className="flex space-x-2 mt-4 opacity-75">
            <div className="w-2 h-2 rounded-full bg-white/90" />
            <div className="w-2 h-2 rounded-full bg-white/90" />
            <div className="w-2 h-2 rounded-full bg-white/90" />
          </div>
        </div>

        <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-white/10 to-transparent rounded-br-3xl opacity-80 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-20 h-20 bg-gradient-to-tl from-white/10 to-transparent rounded-tl-3xl opacity-80 pointer-events-none" />
      </Card>
    </div>
  );
}
